/* eslint-disable linebreak-style */
export const contributorList = {
    alexcui: 'AlexCui',
    sinangentoo: 'SinanGentoo',
    frank782: 'frank_782',
    hydrostic: 'Hydrostic',
    solstice23: 'solstice23',
    e4361: 'e4361',
    sparrowhe: 'SparrowHe',
    stevexmh: 'SteveXMH',
    waterblock79: 'waterblock79',
    jasonxu: 'JasonXu',
    zerlight: 'Zerlight',
    soilzhu: 'SoilZhu',
    bleshi: 'BleShi',
    xiaoji4093: 'xiaoji4093',
    hotover: 'Hotover',
    lmlanmei: 'LMLanmei',
    yuan3old: 'Yuan3old',
    someoneyoung: 'Someone_Young',
    jasonjia: 'JasonJia',
    unknown: 'Unknown contributor',
    lyricepic: 'LyricEpic',
    cyarice: 'Cya_Rice',
    afadian: 'Afadian_c5qE',
    mbzzw: 'mbzzw'
};
